<hx-form-group
  [error]="_hasError()"
  [style.display]="'flex'"
  [style.flex-direction]="isQuestionHorizontal() || labelHorizontally() ? 'row' : 'column'"
  [style.align-items]="isQuestionHorizontal() || labelHorizontally() ? 'flex-start' : 'stretch'"
  [style.gap]="labelHorizontally() ? 'calc(var(--space-4, 4) * 1px)' : 'calc(var(--space-8, 8) * 1px)'">
  <!-- Question Label Container (for labelHorizontally) -->
  @if (labelHorizontally() && showQuestion()) {
    <div class="label-column">
      <hx-label
        [description]="question()"
        [required]="required()"
        [subtitle]="subLabel()"
        [fontWeight]="labelFontWeight()"
        [fontSize]="labelFontSize()"
        [subtitleFontWeight]="subtitleFontWeight()"
        [subtitleFontSize]="subtitleFontSize()"
        [color]="labelColor()"
        [subtitleColor]="subtitleColor()"
        [id]="'question-' + _uniqueId"
        [tooltip]="tooltip()"
        [tooltipPosition]="tooltipPosition()"
        [tooltipColor]="tooltipColor()"></hx-label>
      @if (hint()) {
        <span hx-hint>{{ hint() }}</span>
      }
    </div>
  }

  <!-- Question Label (when labelHorizontally is false) -->
  @if (!labelHorizontally() && showQuestion()) {
    <hx-label
      [description]="question()"
      [required]="required()"
      [subtitle]="subLabel()"
      [fontWeight]="labelFontWeight()"
      [fontSize]="labelFontSize()"
      [subtitleFontWeight]="subtitleFontWeight()"
      [subtitleFontSize]="subtitleFontSize()"
      [color]="labelColor()"
      [subtitleColor]="subtitleColor()"
      [id]="'question-' + _uniqueId"
      [tooltip]="tooltip()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"></hx-label>
  }

  <!-- Checkbox Group -->
  @if (labelHorizontally()) {
    <div class="checkbox-column">
      <div
        role="group"
        [attr.aria-labelledby]="showQuestion() ? 'question-' + _uniqueId : null"
        class="hx-checkbox-group"
        [class.horizontal]="orientation() === 'horizontal' && _getValidColumns() === null"
        [class.vertical]="orientation() === 'vertical' && _getValidColumns() === null"
        [class.grid]="_getValidColumns() !== null"
        [class.justify]="justify() && orientation() === 'horizontal' && _getValidColumns() === null"
        [class.hx-checkbox-group--subcontrol-start]="subControlPosition() === 'start' || !subControlPosition()">
        @for (option of _effectiveOptions(); track option.value) {
          <div
            class="checkbox-with-datepicker-wrapper"
            [style.display]="subControlPosition() === 'start' || !subControlPosition() ? null : 'flex'"
            [style.flex-direction]="subControlPosition() === 'start' || !subControlPosition() ? null : 'column'"
            [style.align-items]="subControlPosition() === 'start' || !subControlPosition() ? null : 'flex-start'"
            [style.gap]="
              subControlPosition() === 'start' || !subControlPosition() ? null : 'calc(var(--space-8, 8) * 1px)'
            "
            [style.margin-bottom]="showDatepicker() ? 'calc(var(--space-8, 8) * 1px)' : '0'">
            <div [style.display]="'flex'" [style.gap]="'calc(var(--space-16, 16) * 1px)'">
              <hx-checkbox
                [options]="[{ label: option.label, value: option.value }]"
                [selectedValues]="_selectedValues().has(option.value) ? [option.value] : []"
                [disabled]="disabled() || !!option.disabled || readonly()"
                (selectedValuesChange)="_handleCheckboxChangeNew(option.value, $event)"
                [style.min-width]="showDatepicker() ? '200px' : 'auto'"></hx-checkbox>
              @if (showDatepicker()) {
                @if (_getDateControl(option.value); as dateCtrl) {
                  <hx-datepicker
                    [formControl]="dateCtrl"
                    [checkboxEnabled]="_selectedValues().has(option.value)"
                    [disabled]="disabled() || !!option.disabled || readonly()"
                    [requiredErrorMessage]="dateRequiredErrorMessage()"
                    [mode]="datePickerMode()"
                    [displayFormat]="displayFormat()"
                    [restrictToPastOrToday]="restrictToPastOrToday()"
                    [restrictToTodayOrFuture]="restrictToTodayOrFuture()"
                    [min]="_effectiveMinDate()"
                    [max]="_effectiveMaxDate()"
                    [allowedYears]="allowedYears() || null"
                    [style.width]="'calc(var(--space-60, 60) * 3px)'"
                    [style.flex-shrink]="'0'"></hx-datepicker>
                }
              }
            </div>
            @if (optionTemplate()) {
              <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: option.value }"></ng-container>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <div
      role="group"
      [attr.aria-labelledby]="showQuestion() ? 'question-' + _uniqueId : null"
      class="hx-checkbox-group"
      [class.horizontal]="orientation() === 'horizontal' && _getValidColumns() === null"
      [class.vertical]="orientation() === 'vertical' && _getValidColumns() === null"
      [class.grid]="_getValidColumns() !== null"
      [class.justify]="justify() && orientation() === 'horizontal' && _getValidColumns() === null"
      [class.hx-checkbox-group--subcontrol-start]="subControlPosition() === 'start' || !subControlPosition()">
      @for (option of _effectiveOptions(); track option.value) {
        <div
          class="checkbox-with-datepicker-wrapper"
          [style.display]="subControlPosition() === 'start' || !subControlPosition() ? null : 'flex'"
          [style.flex-direction]="subControlPosition() === 'start' || !subControlPosition() ? null : 'column'"
          [style.align-items]="subControlPosition() === 'start' || !subControlPosition() ? null : 'flex-start'"
          [style.gap]="
            subControlPosition() === 'start' || !subControlPosition() ? null : 'calc(var(--space-8, 8) * 1px)'
          "
          [style.margin-bottom]="showDatepicker() ? 'calc(var(--space-8, 8) * 1px)' : '0'">
          <div [style.display]="'flex'" [style.gap]="'calc(var(--space-16, 16) * 1px)'">
            <hx-checkbox
              [options]="[{ label: option.label, value: option.value }]"
              [selectedValues]="_selectedValues().has(option.value) ? [option.value] : []"
              [disabled]="disabled() || !!option.disabled || readonly()"
              (selectedValuesChange)="_handleCheckboxChangeNew(option.value, $event)"
              [style.min-width]="showDatepicker() ? '200px' : 'auto'"></hx-checkbox>
            @if (showDatepicker()) {
              @if (_getDateControl(option.value); as dateCtrl) {
                <hx-datepicker
                  [formControl]="dateCtrl"
                  [checkboxEnabled]="_selectedValues().has(option.value)"
                  [disabled]="disabled() || !!option.disabled || readonly()"
                  [requiredErrorMessage]="dateRequiredErrorMessage()"
                  [mode]="datePickerMode()"
                  [displayFormat]="displayFormat()"
                  [restrictToPastOrToday]="restrictToPastOrToday()"
                  [restrictToTodayOrFuture]="restrictToTodayOrFuture()"
                  [min]="_effectiveMinDate()"
                  [max]="_effectiveMaxDate()"
                  [allowedYears]="allowedYears() || null"
                  [style.width]="'calc(var(--space-60, 60) * 3px)'"
                  [style.flex-shrink]="'0'"></hx-datepicker>
              }
            }
          </div>
          @if (optionTemplate()) {
            <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: option.value }"></ng-container>
          }
        </div>
      }
    </div>
  }

  <!-- Reason Field for "Other" Option -->
  @if (_isOtherSelected() && showInputOnOther()) {
    <div class="reason-field" style="margin-top: calc(var(--space-12, 12) * 1px)">
      @let op = $any(otherInputProps()) ?? {};
      @if (reasonControl(); as rc) {
        <hx-input
          [type]="op.type ?? 'text'"
          [label]="reasonLabel()"
          [attr.id]="'reason-' + _uniqueId"
          [placeholder]="op.placeholder ?? reasonPlaceholder()"
          [subtitle]="op.subtitle ?? ''"
          [hint]="op.hint ?? ''"
          [formControl]="rc"
          [maxlength]="op.maxlength ?? reasonMaxLength()"
          [minlength]="op.minlength"
          [pattern]="op.pattern"
          [multiline]="!!op.multiline"
          [autoExpand]="!!op.autoExpand"
          [rows]="op.rows ?? 3"
          (blur)="_handleReasonBlur()"
          (valueChange)="_handleReasonChange($event.value)"
          (input)="_handleReasonChange($any($event.target).value)"
          [error]="!!_reasonFieldHasError()"
          [required]="true"
          [requiredErrorMessage]="_reasonErrorMessage()"></hx-input>
      } @else {
        <hx-input
          [type]="op.type ?? 'text'"
          [label]="reasonLabel()"
          [attr.id]="'reason-' + _uniqueId"
          [placeholder]="op.placeholder ?? reasonPlaceholder()"
          [subtitle]="op.subtitle ?? ''"
          [hint]="op.hint ?? ''"
          [maxlength]="op.maxlength ?? reasonMaxLength()"
          [minlength]="op.minlength"
          [pattern]="op.pattern"
          [multiline]="!!op.multiline"
          [autoExpand]="!!op.autoExpand"
          [rows]="op.rows ?? 3"
          (blur)="_handleReasonBlur()"
          (valueChange)="_handleReasonChange($event.value)"
          (input)="_handleReasonChange($any($event.target).value)"
          [error]="!!_reasonFieldHasError()"
          [required]="true"
          [requiredErrorMessage]="_reasonErrorMessage()"
          [disabled]="true"></hx-input>
      }
    </div>
  }

  <!-- Hint Text (when labelHorizontally is false) -->
  @if (!labelHorizontally() && hint()) {
    <span hx-hint>{{ hint() }}</span>
  }

  <!-- Error Messages -->
  @if (_hasError()) {
    <span hx-error>
      @if (_internalControl.errors?.['required']) {
        {{ _getErrorMessage('required') }}
      }
      @if (_internalControl.errors?.['minSelection']) {
        {{ _getErrorMessage('minSelection') }}
      }
      @if (_internalControl.errors?.['maxSelection']) {
        {{ _getErrorMessage('maxSelection') }}
      }
    </span>
  }
</hx-form-group>
